import { render, staticRenderFns } from "./GroceryStoresGrid.vue?vue&type=template&id=40057d6a&scoped=true&"
import script from "./GroceryStoresGrid.vue?vue&type=script&lang=js&"
export * from "./GroceryStoresGrid.vue?vue&type=script&lang=js&"
import style0 from "./GroceryStoresGrid.vue?vue&type=style&index=0&id=40057d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40057d6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
